<template>
  <K2Row>
    <K2Row class="flex-1 me-4">
      <input type="text" class="form-control mb-0 inputStudentEmail" disabled v-model="billEmail" />
      <K2Row align="center" class="pointer">
        <i class="material-icons inputStudentEm ailDelete" @click="removeBillingEmail"> delete </i>
      </K2Row>
    </K2Row>
    <el-popover placement="right" width="500" trigger="click" popper-class="student-status- popover">
      <div class="p-3">
        <input type="text" class="form-control" v-model="inputStudentEmailAdd" />
        <el-button v-on:click="billingEmailValidation" type="primary" size="small"> Add </el-button>
      </div>

      <el-button type="primary" slot="reference" :disabled="disabled"> Add Email </el-button>
    </el-popover>
  </K2Row>
</template>

<script>
import K2Row from '@/uiComponents/k2Row/k2Row'
import K2Icon from '@/uiComponents/k2Icon/k2MAIcon'
import { required } from 'vuelidate/lib/validators'
import { lang } from '@/locale'
export default {
  name: 'MultiEmailInput',
  validations: {
    validationGroupBillingEmail: ['inputStudentEmailAdd'],
  },
  props: ['validator', 'disabled', 'email'],
  components: { K2Row },
  mounted() {
    this.billEmail = this.email
  },
  data() {
    return {
      billEmail: '',
      inputStudentEmailAdd: '',
    }
  },
  watch: {
    email(value) {
      if (value) {
        this.billEmail = value
      }
    },
  },
  methods: {
    removeBillingEmail() {
      this.billEmail = ''
      this.$emit('onChange', this.billEmail)
    },
    billingEmailValidation() {
      if (this.inputStudentEmailAdd !== '') {
        const isEmail = this.isValidEmail(this.inputStudentEmailAdd)
        if (!isEmail) {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Email is invalid!'),
          })
        } else {
          if (this.billEmail === '') {
            this.billEmail = this.inputStudentEmailAdd
          } else {
            this.billEmail += ',' + this.inputStudentEmailAdd
          }

          this.inputStudentEmailAdd = ''
          this.$emit('onChange', this.billEmail)
        }
      }
    },
    isValidEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailPattern.test(email)
    },
  },
}
</script>
